import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CheckEmploymentHistoryDialogComponent } from '../check-employment-history-dialog.component';
import { EmploymentType, TEMPORARY_EMPLOYMENT_TYPES_NUMS } from 'src/app/models/enums/employment-type-enum';

@Injectable({
  providedIn: 'root',
})
export class CheckEmploymentHistoryDialogService {
  constructor(private dialog: MatDialog) {}

  checkAndOpenModal(employmentTypeId: EmploymentType | number): MatDialogRef<CheckEmploymentHistoryDialogComponent> | null {
    const typeId = Number(employmentTypeId);

    if (TEMPORARY_EMPLOYMENT_TYPES_NUMS.has(typeId)) {
      return this.openModal();
    }

    return null;
  }

  private openModal(): MatDialogRef<CheckEmploymentHistoryDialogComponent> {
    const dialogRef = this.dialog.open(CheckEmploymentHistoryDialogComponent, {
      disableClose: false,
    });

    return dialogRef;
  }
}
